import { ChiaraBannersBuilderComponent } from '@tvlgiao/bc-supermarket-builder-components';
import React from 'react';
export default {
  ChiaraBannersBuilderComponent,
  React
};